import Select from "react-select";
import {useTranslation} from "react-i18next";

const SearchSelect = ({
    options,
    placeholder = "Select an option",
    onChange,
    styles,
    value,
    defaultValue,
    isMulti = false,
    isClearable = false,
    isDisabled = false,
    name,
}) => {
    const defaultStyles = {
        control: (base) => ({
            ...base,
            height: "31.25px",
            minHeight: "31.25px",
            padding: "0px 0px 0px 6px",
            // border: "1px solid black",
            margin: "0px",
            display: "flex",
            alignItems: "center",
        }),
        valueContainer: (base) => ({
            ...base,
            height: "31.25px",
            display: "flex",
            alignItems: "center",
            padding: "0 6px",
            // border: "1px solid red",
        }),
        singleValue: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            lineHeight: "31.25px",
            // border: "1px solid blue",
        }),
        placeholder: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            lineHeight: "31.25px",
            // border: "1px solid green",
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            height: "31.25px",
            // border: "1px solid pink",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "31.25px",
        }),
        option: (base, {isFocused, isSelected}) => ({
            ...base,
            backgroundColor: isSelected ? "#81d4fa" : isFocused ? "rgba(88,151,251,0.1)" : "transparent",
            color: isSelected ? "#ffffff" : base.color,
            "&:active": {
                backgroundColor: "#81d4fa",
            },
        }),
        menu: (base) => ({
            ...base,
            zIndex: 992,
        }),
    };
    const {t: _tf} = useTranslation("forms");

    const selectProps = {};
    if (name !== undefined) {
        selectProps.name = name;
    }
    if (value !== undefined) {
        selectProps.value = value;
    } else if (defaultValue !== undefined) {
        selectProps.defaultValue = defaultValue;
    } else {
        selectProps.defaultValue = "";
    }

    return (
        <Select
            options={options}
            placeholder={placeholder}
            onChange={onChange}
            styles={styles || defaultStyles}
            noOptionsMessage={() => _tf("labels.nodata")}
            isMulti={isMulti}
            isClearable={isClearable}
            isDisabled={isDisabled}
            {...selectProps}
        />
    );
};

export default SearchSelect;
